<template>
  <div class="dizhi">
    <div v-if="goodform.transportMode==2">
      <el-form-item   label="起运港:" prop="startDirection" class="width1" :rules=" { required: true, message: '请输入起运港', trigger: 'blur' }">
        <el-input  placeholder=""  maxlength="100"    v-model="goodform.startDirection"></el-input>
      </el-form-item>
      <el-form-item label="目的港:" prop="endDirection" class="width1" :rules="  { required: true, message: '请输入目的港', trigger: 'blur' }">
          <el-input  placeholder=""  maxlength="100"    v-model="goodform.endDirection"></el-input>
      </el-form-item>
      <div style="margin: 16px 0;">
        <el-form-item    class="" label="发货人:" prop="deliverPerson"  >
            <el-input  placeholder=""  maxlength="100"    v-model="goodform.deliverPerson"></el-input>
          </el-form-item>
          <el-form-item  class="" label="发货电话:" prop="deliverPhone" >
              <el-input  placeholder=""  maxlength="100"    v-model="goodform.deliverPhone"></el-input>
          </el-form-item>
          <el-form-item  label="发货地址:" prop="deliverAddress" class="diqu1" >
              <el-input  placeholder=""  maxlength="100"    v-model="goodform.deliverAddress"></el-input>
          </el-form-item>
      </div>
       <div>
       <el-form-item  class="" label="收货人:" prop="receivingPerson" >
           <el-input  placeholder=""  maxlength="100"    v-model="goodform.receivingPerson"></el-input>
        </el-form-item>
        <el-form-item  class="" label="收货电话:" prop="receivingPhone" >
          <el-input  placeholder=""  maxlength="100"    v-model="goodform.receivingPhone"></el-input>
        </el-form-item>

        <el-form-item  label="收货地址:" prop="receivingAddress" class="diqu1" >
          <el-input  placeholder=""  maxlength="100"    v-model="goodform.receivingAddress"></el-input>
        </el-form-item>
    </div>
    </div>
    <div v-else>
    <div style="display:flex">
      <div style="padding-left:12px;">
          <el-button type="text"  @click="addxzdzFn(2)" size="mini"><i class="el-icon-location-outline  dizhiIcon" style="color:#67C23A"></i><span class="red">*</span>发货地址薄</el-button>
      </div>
      <div>
        <el-form-item    class="is-required" label="发货人:" prop="deliverPerson" v-if="goodform.deliverAddressId">
          <div style="width:80px">{{goodform.deliverPerson}}</div>
        </el-form-item>
        <el-form-item label="电话:" prop="deliverPhone" v-if="goodform.deliverAddressId">
          <div style="width:80px">{{goodform.deliverPhone}}</div>
        </el-form-item>
        <el-form-item   label="流向:" v-if="goodform.deliverAddressId">
          <div style="width:230px">{{goodform.startDirection}}</div>
        </el-form-item>
        <el-form-item  label="发货地址:" prop="deliverAddress" class="diqu1" v-if="goodform.deliverAddressId">
          <div style="min-width:150px">{{goodform.deliverAddress}}</div>
        </el-form-item>
      </div>
    </div>
    <div style="display:flex">
      <div style="padding-left:12px;">
        <el-button type="text"  @click="addxzdzFn(1)" size="mini"><i class="el-icon-location-outline dizhiIcon" style="color:#F56C6C"></i><span class="red">*</span>收货地址薄</el-button>
      </div>
      <div>
        <el-form-item class="is-required" label="收货人:" prop="receivingPerson" v-if="goodform.receivingAddressId">
          <div style="width:80px">{{goodform.receivingPerson}}</div>
        </el-form-item>
        <el-form-item label="电话:" prop="receivingPhone" v-if="goodform.receivingAddressId">
          <div style="width:80px">{{goodform.receivingPhone}}</div>
        </el-form-item>
        <el-form-item label="流向:" prop="receivingCompany" v-if="goodform.receivingAddressId">
          <div style="width:230px">{{goodform.endDirection}}</div>
        </el-form-item>
        <el-form-item  label="收货地址:" prop="receivingAddress" class="diqu1" v-if="goodform.receivingAddressId">
          <div style="min-width:150px">{{goodform.receivingAddress}}</div>
        </el-form-item>
      </div>
    </div>
    <div >
      <el-form-item label="是否往返:"  prop="arriveDepartFlag" :rules="[{required: true, message: '请选择往返',  trigger: 'change', },]">
        <el-radio-group v-model="goodform.arriveDepartFlag"   >
          <el-radio label="是">是</el-radio>
          <el-radio label="否">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="共计:">
        <span class="red">{{goodform.kilometres?goodform.kilometres:'-'}}</span>公里
      </el-form-item>
    </div>
    </div>
    <el-dialog  title="选择地址" :close-on-click-modal="false" :close-on-press-escape="false"  @close="dialogVisible = false"
     :visible.sync="dialogVisible" width="1300px" center append-to-body>
      <div>
        <publicAddress v-if="dialogVisible" :iszujian="1" @handleCurrentChange="handleCurrentChange"></publicAddress>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import publicAddress from '@/views/newTMS/publicFiles/publicAddress.vue'
import { findKilometres, getPrice } from '@/api/newTMS'
export default {
  name: 'addDizhi',
  components: {
    publicAddress
  },
  props: {
    goodform: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isCQ: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: false,
      addressType: 1
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    if (!this.goodform.arriveDepartFlag) {
      this.$set(this.goodform, 'arriveDepartFlag', '否')
    }
  },
  methods: {
    // 长期货源算价格
    // getPriceFn () {
    //   if (this.goodform.productTypeName == '冷卷' || this.goodform.productTypeName == '热卷' || this.goodform.productTypeName == '中厚板' || this.goodform.productTypeName == '剪切板') {
    //     if (this.goodform.productTypeName && (this.goodform.orderBusinessTypeName == '首钢短倒' || this.goodform.orderBusinessTypeName == '自家倒短业务') && this.goodform.endDirection) {
    //       getPrice({
    //         productType: (this.goodform.productTypeName == '中厚板' || this.goodform.productTypeName == '剪切板') ? 3 : this.goodform.productTypeName == '冷卷' ? 1 : 2, // 1. 冷卷 ，2 热卷，3. 中厚板
    //         keyWords: this.goodform.endDirection.replace(/-/g, '') + this.goodform.receivingAddress
    //       }).then(res => {
    //         this.$set(this.goodform, 'incomeUnitPrice', res)
    //       }).catch(error => {
    //         this.$message({
    //           showClose: true,
    //           message: error.message,
    //           type: 'error',
    //           onClose () {
    //           }
    //         })
    //       })
    //     }
    //   }
    // },
    // 选择地址
    addxzdzFn (flag) {
      this.addressType = flag
      this.dialogVisible = true
    },
    handleCurrentChange (row) {
      if (!this.rule.xingming.test(row.person)) {
        this.$alert('联系人长度只支持2-20 个字符，必须为汉字。请修改后重新选择！', '系统提示')
        return
      }
      if (this.addressType == 1) {
        if (row.id == this.goodform.deliverAddressId) {
          this.$alert('收发货地址不能一样', '系统提示')
          return
        }
        // 收货
        this.$set(this.goodform, 'receivingCompany', row.company)
        this.$set(this.goodform, 'receivingPerson', row.person)
        this.$set(this.goodform, 'receivingPhone', row.phone)
        this.$set(this.goodform, 'receivingAddress', row.address)
        this.$set(this.goodform, 'receivingTaxpayerNumber', row.taxpayerNumber)
        this.$set(this.goodform, 'endDirection', row.name)
        this.goodform.receivingProvinceCode = row.provinceCode
        this.goodform.receivingCityCode = row.cityCode
        this.goodform.receivingAreaCode = row.areaCode
        this.goodform.receivingProvinceName = row.provinceName
        this.goodform.receivingCityName = row.cityName
        this.goodform.receivingAreaName = row.areaName
        this.goodform.receivingAddressId = row.id
        this.goodform.receivingLongitude = row.longitude
        this.goodform.receivingLatitude = row.latitude
        // if (this.isCQ) {
        //   this.getPriceFn()
        // }
      } else {
        if (row.id == this.goodform.receivingAddressId) {
          this.$alert('收发货地址不能一样', '系统提示')
          return
        }
        // 发货
        this.$set(this.goodform, 'deliverCompany', row.company)
        this.$set(this.goodform, 'deliverPerson', row.person)
        this.$set(this.goodform, 'deliverPhone', row.phone)
        this.$set(this.goodform, 'deliverAddress', row.address)
        this.$set(this.goodform, 'deliverTaxpayerNumber', row.taxpayerNumber)
        this.$set(this.goodform, 'startDirection', row.name)
        this.goodform.deliverProvinceCode = row.provinceCode
        this.goodform.deliverCityCode = row.cityCode
        this.goodform.deliverAreaCode = row.areaCode
        this.goodform.deliverProvinceName = row.provinceName
        this.goodform.deliverCityName = row.cityName
        this.goodform.deliverAreaName = row.areaName
        this.goodform.deliverAddressId = row.id
        this.goodform.deliverLongitude = row.longitude
        this.goodform.deliverLatitude = row.latitude
      }
      this.getGLS()
      this.dialogVisible = false
    },
    getGLS () {
      if (this.goodform.deliverLongitude && this.goodform.receivingLongitude) {
        findKilometres({
          deliverLongitude: this.goodform.deliverLongitude,
          deliverLatitude: this.goodform.deliverLatitude,
          receivingLongitude: this.goodform.receivingLongitude,
          receivingLatitude: this.goodform.receivingLatitude,
          arriveDepartFlag: this.goodform.arriveDepartFlag
        }).then(res => {
          this.$set(this.goodform, 'kilometres', res)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      } else {
        this.$set(this.goodform, 'kilometres', '0')
      }
    }

  },
  destroyed () {
    this.dialog = false
  }
}
</script>

<style scoped lang='less'>
.disabled /deep/.el-input__inner {
    background: #eff0f1;
}
.dizhiIcon{
  font-size: 18px;
  margin-right: 4px;
}
.dizhi{
  /deep/.el-form-item--mini.el-form-item{
    margin-bottom:0!important;
  }
}
.width1  /deep/.el-input__inner{
  width: 260px;
}
</style>
